import React from 'react';
import { connect } from 'react-redux';
import moment from "moment";
import * as _ from 'lodash';
import './style.css';
import apiUrl from '../../utils/api-url'
import LayoutWrapper from '../../layouts/LayoutWrapper.js';
import weeklyQuestionSummaryService from '../../services/WorkReport/weekly-question-summary-service';
import { fetchUserGroupList } from '../../actions/daily-report-actions.js';
import {
	fetchQuestionSummaryList,
	setWeeklyQuestionSummaryFilter,
	increaseQuestionSummaryLoadCounter
} from '../../actions/weely-question-summary-actions';
import {
	Table,
	Button,
	Modal,
	Spin,
	message,
	Row,
	Col,
	Form,
	Select,
	DatePicker
} from 'antd';
// import DynamicForm from "../../components/frame/DynamicForm";
// import { fetchEmployeesList } from '../../actions/employee-management-actions.js';
const webConfig = require('../../config.json');
const dateFormat = "YYYY-MM-DD";
const Option = Select.Option;
class WeeklyQuestionSummary extends React.Component {


	state = {
		currentData: "loading",
		selectedRowKeys: [],
		disablesave: false,
		sendEmailModalStatus: false,
		filters: {
			start_date: "",
			end_date: "",
			page: 1,
			export_type:1
		}

	}

	rowSelection = {
		onChange: (selectedRowKeys, selectedRows) => {
			let ids = selectedRows.map(row => row.id);
			this.setState({ selectedRowKeys: ids });
		},
		getCheckboxProps:
			record => ({
				disabled: false,
			}),
		selectedRowKeys: this.state.selectedRowKeys
	}

	componentWillMount() {
		if ("loaded" !== this.props.workReport.weeklyQuestionSummaryStatus) {
			this.props.increaseQuestionSummaryLoadCounter();
		}
		if (this.props.routing.location.pathname.split('/')[3]) {
			this.setState({
				openDetail: false,
				currentModalStatus: true
			});

		}
	}
	componentWillReceiveProps(nextProps) {
		console.log(nextProps);
		if (nextProps.workReport.weeklyQuestionSummaryLoadCounter !== this.props.workReport.weeklyQuestionSummaryLoadCounter) {
			let gets = {};
			Object.keys(nextProps.workReport.weeklyQuestionSummaryFilters).forEach(key => {
				if (nextProps.workReport.weeklyQuestionSummaryFilters[key]) {
					gets[key] = nextProps.workReport.weeklyQuestionSummaryFilters[key];
				}
			});
			this.props.fetchQuestionSummaryList(gets);
		}
	}

	setStartDateFilter = (value, date) => {

		this.setState({ filters: { ...this.state.filters, start_date: value } }, () => {
			this.props.setWeeklyQuestionSummaryFilter(this.state.filters)
		})
	}


	setEndDateFilter = (value, date) => {
		this.setState({ filters: { ...this.state.filters, end_date: value } }, () => {
			this.props.setWeeklyQuestionSummaryFilter(this.state.filters)
		})

	}
	setStartDate = (val) => {
		// console.log(val);
		if (val) {
			val = val.format("YYYY-MM-DD")
		}
		this.setState({ date_1: val });
		// console.log(this.state.date_1);
	}
	setEndDate = (val) => {
		// console.log(val);
		if (val) {
			val = val.format("YYYY-MM-DD")
		}
		this.setState({ date_2: val });
		// console.log(this.state.date_1);
	}

	setStatusFilter = event => {
		this.props.setWeeklyReportFilter({ status: event.target.value, page: 1 });
	}

	setPageFilter = pagination => {
		this.props.setWeeklyReportFilter({ page: pagination.current });
	}

	viewWeeklyQuestionSummaryReport = (record, index) => {
		this.setState({
			currentWeekInfo: record,
			currentModalStatus: true
		})

		// function isSummary(element, index, array) {
		// 	return (element.is_summary);
		// }
		weeklyQuestionSummaryService.getQuestionSummaryDetail({ id: record.week_number }, (res) => {
			var keys = _.filter(res.data, { is_summary: true }).map(row => row.id)
			this.setState({
				currentData: _.orderBy(res.data, ['is_summary'], ['desc']),
				selectedRowKeys: keys
			}, err => {
				// currentData:"error"
			});
		})
	}

	closeCurrentModal = (record, index) => {
		this.setState({
			currentModalStatus: false,
			sendEmailModalStatus: false,
			currentData: "loading",
		})
	}
	closeSendModal = (record, index) => {
		this.setState({
			sendEmailModalStatus: false,
		})
	}

	SaveQuestionSummary = () => {

		if (this.state.selectedRowKeys.length === 0) {
			message.error("请至少选择一个问题。")
			return;
		}

		this.setState({
			disablesave: true
		})
		var posts = {
			ids: this.state.selectedRowKeys,
			week_number: this.state.currentWeekInfo.week_number
		}
		weeklyQuestionSummaryService.updateQuestionSummary(posts, res => {
			message.success("保存成功！")
			this.orderCurrentData();
			this.setState({
				disablesave: false
			})
		}, err => {
			message.error("保存失败")
			this.setState({
				disablesave: false
			})
		}
		)
	}
	SendQuestionSummary = () => {

		if (this.state.selectedRowKeys.length === 0) {
			message.error("请至少选择一个问题。")
			return;
		}

		this.setState({
			sendEmailModalStatus: true
		})
		this.props.fetchUserGroupList({ page_size: 1000 });
	}

	SaveAndSendQuestionSummary = () => {

		if (!this.state.userGroup) {
			message.error("请选择一个群组。")
			return;
		}

		this.setState({
			disablesave: true
		})

		var posts = {
			ids: this.state.selectedRowKeys,
			week_number: this.state.currentWeekInfo.week_number,
			user_group: this.state.userGroup
		}
		weeklyQuestionSummaryService.updateAndSendQuestionSummary(posts, res => {
			if (res.data.Success) {
				message.success("保存并且邮件发送成功！");
				this.orderCurrentData();
				this.closeCurrentModal();
			}
			else {
				res.data.Errors.forEach(error => message.error(error))
			}

			this.setState({
				disablesave: false
			})
		}, err => {
			message.error("邮件发送失败")
			this.setState({
				disablesave: false
			})
		})
	}
	handleEmailGroupChange = (value) => {
		this.setState({
			userGroup: value
		})
	}

	orderCurrentData = () => {
		const selectIds = this.state.selectedRowKeys;
		var result = []
		_.forEach(this.state.currentData, function (item) {
			if (selectIds.indexOf(item.id) > -1) {
				item.is_summary = true
			}
			else {
				item.is_summary = false
			}
			result.push(item)
		})
		this.setState({
			currentData: _.orderBy(result, ['is_summary'], ['desc'])
		})
	}

	download = () => {
		weeklyQuestionSummaryService.downloadQuestionSummaryDetail({ id: this.state.currentWeekInfo.week_number },
			res => {
				if (res.data.path) {
					var path = apiUrl.url + "/" + res.data.path;
					window.open(path, '_blank');
				}
				else {
					message.error(res.data.Errors[0])
				}
			},
			err => {
				message.error("下载失败")
			}
		)
	}
	publicExport = () => {
		let gets = {};
		Object.keys(this.state.filters).forEach(key => {
			if (this.state.filters[key]) {
				gets[key] = this.state.filters[key];
			}
		})
		gets.start_date = gets.start_date === undefined ? "" : gets.start_date.format('YYYY-MM-DD')
		gets.end_date = gets.end_date === undefined ? "" : gets.end_date.format('YYYY-MM-DD')
		delete gets.page;
		let ref = Modal.info({
			content: "正在准备需要下载的文件, 下载文件可能被浏览器阻挡, 请注意！"
		});

		weeklyQuestionSummaryService.exportSummary(gets, res => {
			ref.destroy();
			if (res.data.Success) {
				window.open(res.data.Message);
			} else {
				message.error('导出数据失败, ' + res.data.Errors[0], 4);
			}
		}, err => message.error('导出数据失败, 请联系管理员', 4))

	}
  //切换导出类型
  setExportTypeFilter = value => {
    this.setState(
      {
        filters: {
          ...this.state.filters,
          export_type: value,
        }
      }
    );
  }

	render() {

		const { currentUser } = this.props.user
		const reportColumn = [{
			title: '报告时间',
			dataIndex: 'week_str',
			key: 'week_str',
		}, {
			title: '开始时间',
			dataIndex: 'start_date',
			key: 'start_date',
		}, {
			title: '结束时间',
			dataIndex: 'end_date',
			key: 'end_date',
		}, {
			title: '操作',
			dataIndex: 'action',
			key: 'action',
			className: "daily-report-action",
			render: (text, record, index) => (
				<span>
					<Button icon="info-circle-o" size="small" className="row-action-btn"
						onClick={this.viewWeeklyQuestionSummaryReport.bind(this, record, index, true)}>详情</Button>
				</span>
			)
		}
		];
		this.rowSelection.selectedRowKeys = this.state.selectedRowKeys

		const formColumn = [{
			title: '反馈人',
			dataIndex: 'employee_name',
			key: 'employee_name',
			width: 150,
		}, {
			title: '部门',
			dataIndex: 'department_name',
			key: 'department_name',
			width: 150,
		}, {
			title: '问题',
			dataIndex: 'content',
			key: 'content',
		},

		];

		return (
			<div className="app-module-item">
				<Modal width="1000px"
					visible={this.state.currentModalStatus}
					title={this.state.currentWeekInfo ? this.state.currentWeekInfo.week_str + " 问题汇总" : "问题汇总"}
					destroyOnClose={true}
					onCancel={this.closeCurrentModal}
					footer={[
						// this.props.access.myWeeklyReport.save_value && this.state.openDetail ? null : <Button key="保存" type="primary"
						// 	onClick={this.saveCurrentReport.bind(this, 0)}>保存</Button>,
						// this.props.access.myWeeklyReport.submit_value && this.state.openDetail ? null : <Button key="提交" type="primary"
						// 	onClick={this.submitCurrentReport.bind(this, 1)}>提交</Button>,
						// <Button key="关闭" onClick={this.closeCurrentModal}>关闭</Button>,
					]}>
					{this.state.currentData === "loading" && <div style={{ textAlign: 'center', margin: '100px 0px' }}>
						<Spin size="large" />
					</div>}
					{this.state.currentData === "error" && <div style={{ textAlign: 'center', margin: '100px 0px' }}>
						{webConfig.httpFetchErrorInformation}
					</div>}

					{!(this.state.currentData === "error" || this.state.currentData === "loading") &&

						<div style={{ textAlign: "center", margin: "0px 0px 5px", height: "700px", overflowY: "auto" }}>
							<Row style={{}}>
								<Col span={18} style={{ fontSize: "32px", height: "95px", lineHeight: "40px", textAlign: "left", paddingLeft: "40px" }}>
									<span style={{ fontWeight: "bold" }}>Weekly Work Report</span><br />
									<span style={{ fontSize: "20px", fontWeight: "bold", paddingLeft: "5px" }}>每周问题汇总</span>
								</Col>
								<Col span={6} style={{ fontSize: "14px", height: "30px", lineHeight: "30px", textAlign: "right", paddingRight: "40px" }}>
									{/* <span style={{}}>HS华山校</span><br/>
									<span style={{}}>HS华山校</span><br/>
									<span style={{}}>HS华山校</span> */}

									<Button key="download" onClick={this.download}>下载</Button>
								</Col>
							</Row>
							<Row>
								<Col span={24} style={{ height: "550px", overflowX: "auto" }}>
									<Table columns={formColumn}
										dataSource={this.state.currentData}
										rowKey={record => record.id}
										rowSelection={this.rowSelection}
										pagination={false} />
								</Col>
							</Row>
							<Row style={{ margin: '10px' }}>
								<Col span={12} >
									{currentUser.PermissionDict.questionsSummary.save_summary_value && <Button key="send" onClick={this.SendQuestionSummary} disabled={this.state.disablesave}>发送邮件</Button>}
								</Col>
								<Col span={12} >
									{currentUser.PermissionDict.questionsSummary.send_summary_value && <Button key="save" onClick={this.SaveQuestionSummary} disabled={this.state.disablesave}>保存汇总</Button>}
								</Col>
							</Row>
						</div>
					}
				</Modal>
				<Modal visible={this.state.sendEmailModalStatus}
					onCancel={this.closeSendModal}
					title="发送汇总"
					footer={null}
				>
					{this.props.dailyReports && this.props.dailyReports.userGroupList &&
						<Row style={{ margin: '10px' }}>
							<Col span={8} style={{ textAlign: 'right', padding: '10px' }} >
								群组：
						</Col>
							<Col span={16} style={{ textAlign: 'left' }}>
								<Select style={{ width: 240 }} onChange={this.handleEmailGroupChange}>
									{this.props.dailyReports.userGroupList.Data.map(i => <Option key={i.id}>{i.name}</Option>)}
								</Select>
							</Col>

							<Col span={20} style={{ textAlign: 'center', margin: '10px' }}>
								<Button key="关闭" onClick={this.SaveAndSendQuestionSummary} disabled={this.state.disablesave}>发送</Button>
							</Col>
						</Row>
					}

				</Modal>
				<div style={{ marginBottom: "20px" }}>

					<div className="colAction" style={{ float: "left", margin: "0px 10px 10px 0px" }}>
						<span style={{ marginRight: "5px" }}>开始时间 : </span>
						<DatePicker onChange={this.setStartDateFilter}
							value={this.state.filters.start_date}
						/>
					</div>
					<div className="colAction" style={{ float: "left", margin: "0px 10px 10px 0px" }}>
						<span style={{ marginRight: "5px" }}>结束时间 : </span>
						<DatePicker onChange={this.setEndDateFilter}
							value={this.state.filters.end_date} />
					</div>
					<div className="colAction" style={{ float: "left", margin: "0px 10px 10px 0px" }}>
						<span style={{ marginRight: "5px" }}>导出类型 : </span>
						<Select style={{ width: "200px", margin: '0px 5px 10px 0px' }}  onChange={this.setExportTypeFilter}  value={this.state.filters.export_type}>
							<Select.Option key={1} value={1}>{'周报汇总'}</Select.Option>
							<Select.Option key={2} value={2}>{'疫情期间问题反馈'}</Select.Option>
						</Select>
					</div>
					<div className="colAction" style={{ float: "left", margin: "0px 10px 10px 0px" }}>
						<Button icon="cloud-download-o"
							type="primary"
							size="default"
							onClick={this.publicExport} >
							<span>导出</span>
						</Button>
					</div>
					<div style={{ clear: "both" }}></div>
				</div>
				<div>
					{(() => {
						switch (this.props.workReport.weeklyQuestionSummaryStatus) {
							case "loaded":
								return (
									<Table columns={reportColumn}
										dataSource={this.props.workReport.weeklyQuestionSummaryData}

										pagination={{
											total: this.props.workReport.weeklyReportData.Total,
											pageSize: this.props.workReport.weeklyReportData.pageSize,
											current: this.props.workReport.weeklyReportFilters.page
										}}
										onChange={this.setPageFilter} />);
							case "error":
								return (
									<div style={{ textAlign: 'center', margin: '100px 0px' }}>
										{webConfig.httpFetchErrorInformation}
									</div>);
							case "loading":
							case "reload":
							case "unload":
								return (
									<div style={{ textAlign: 'center', margin: '100px 0px' }}>
										<Spin size="large" />
									</div>);
							default:
								return null;
						}
					})()}
				</div>
			</div>
		)
	}
}
const mapStateToProps = state => {
	return {
		workReport: state.workReport,
		dailyReports: state.dailyReports,
		routing: state.routing,
		employeeManagement: state.employeeManagement,
		user: state.user
	}
}
const mapDispatchToProps = {
	fetchQuestionSummaryList,
	setWeeklyQuestionSummaryFilter,
	increaseQuestionSummaryLoadCounter,
	fetchUserGroupList
}

WeeklyQuestionSummary = Form.create()(WeeklyQuestionSummary);

export default LayoutWrapper(connect(mapStateToProps, mapDispatchToProps)(WeeklyQuestionSummary));





// WEBPACK FOOTER //
// ./src/routes/WorkReport/WeeklyQuestionSummary.js